import React from 'react';

const MediaContext = React.createContext(null);

export const Provider = MediaContext .Provider;
export const Consumer = MediaContext .Consumer;

export default MediaContext;
